import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c1-one-one-one-three',
  templateUrl: './c1-one-one-one-three.component.html',
  styleUrls: ['./c1-one-one-one-three.component.scss']
})
export class C1OneOneOneThreeComponent implements OnInit {
  pdfSrc: string[] = ['/assets/pdf/NAAC/Criterion 1/1.1.1_CURRICULUM DELIVERY/1.1.1.3_TIME TABLE.pdf'];
  src: string;
  constructor() { }

  ngOnInit(): void {
    this.src = this.pdfSrc[0];
  }
}
